import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 9.54722V14.4557C7 16.4167 7 17.3972 7.40831 17.9339C7.76395 18.4013 8.30709 18.6888 8.89362 18.72C9.567 18.7559 10.3778 18.2046 11.9994 17.1019L15.6086 14.6476C16.913 13.7607 17.5652 13.3172 17.7935 12.7608C17.9932 12.2743 17.9932 11.7287 17.7935 11.2421C17.5652 10.6858 16.913 10.2423 15.6086 9.3553L11.9994 6.90106C10.3778 5.79837 9.567 5.24703 8.89362 5.28289C8.30709 5.31414 7.76395 5.60162 7.40831 6.06907C7 6.60573 7 7.58623 7 9.54722Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPlay;
